export default {
  transport_to_work: {
    title: 'Reise til og fra jobb',
  },
  work_transport_local: {
    title: 'Korte reiser i jobb',
  },
  work_transport_flight: {
    title: 'Lange reiser i jobb',
  },
  general_info: {
    title: 'Generell informasjon',
  },
  travel_to_work: {
    title: 'Reise til jobb',
  },
  short_work_travel: {
    title: 'Korte reiser (jobb)',
  },
  long_work_travel: {
    title: 'Lange reiser (jobb)',
  },
  organisation: {
    title: 'Organisasjon',
  },
  household: {
    title: 'Husholdning',
  },
  transport: {
    title: 'Transport',
  },
  food: {
    title: 'Mat',
  },
  food_waste: {
    title: 'MatVinn',
  },
  consumption: {
    title: 'Forbruk',
  },
  energy: {
    title: 'Energi',
  },
  sustainability_knowledge: {
    title: 'Bærekraftskunnskap',
  },
  plastic: {
    title: 'Plast',
  },
  other: {
    title: 'Annen',
  },
};
